import { defineMessages } from "react-intl";

const PREFIX = "User.UserActions";
export default defineMessages({
  save: {
    id: `${PREFIX}.save`,
    defaultMessage: "Save",
  },
  cancel: {
    id: `${PREFIX}.cancel`,
    defaultMessage: "Cancel",
  },
});
